<template>
  <div class="page page-contact">
    <section class="section">
      <div class="section-inner">
        <div class="section-header">
          <h2 class="section-title">联系方式</h2>
          <p class="section-subtitle">期待与您建立长期、稳定、互信的合作关系。</p>
        </div>
        <div class="contact-body">
          <div class="contact-row">
            <div class="label">商务合作电话</div>
            <div class="value">17768129723 （工作日 9:00-18:00）</div>
          </div>
          <div class="contact-row">
            <div class="label">商务合作邮箱</div>
            <div class="value">454520997@qq.com</div>
          </div>
          <div class="contact-row">
            <div class="label">售后支持邮箱</div>
            <div class="value">454520997@qq.com</div>
          </div>
          <div class="contact-row">
            <div class="label">公司地址</div>
            <div class="value">南京市栖霞区尧化街道上城风景北苑16幢1305-24-001室</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ContactPage'
}
</script>

<style scoped>
.page {
  background: #f4f8fc;
}

.contact-body {
  background: #ffffff;
  border-radius: 0;
  border: 1px solid #e5e7eb;
  border-left: 4px solid #f43f5e;
  padding: 8px 22px;
  box-shadow: none;
}

.contact-row {
  display: flex;
  padding: 14px 0;
  font-size: 14px;
}

.contact-row + .contact-row {
  border-top: 1px solid #f3f4f6;
}

.label {
  width: 120px;
  color: #9ca3af;
}

.value {
  flex: 1;
  color: #1e293b;
}

@media (max-width: 640px) {
  .contact-row {
    flex-direction: column;
  }

  .label {
    margin-bottom: 2px;
  }
}
</style>

